import JSONUtils from './JSONUtils';

export const LocalStorageUtils = {
  getObject(key) {
    try {
      const serializedItem = localStorage.getItem(key);
      if (serializedItem === null) {
        return undefined;
      }
      return JSONUtils.parseJson(serializedItem);
    } catch (err) {
      return undefined;
    }
  },

  saveObject(key, value) {
    try {
      const serializedItem = JSONUtils.stringifyJson(value);
      localStorage.setItem(key, serializedItem);
    } catch (err) {
      //ignore error
      console.log('cannot save to localStorage');
    }
  },

  removeObject(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.log('cannot remove from localStorage');
    }
  },

  removeObjectWithPrefix(prefix) {
    try {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith(prefix)) {
          localStorage.removeItem(key);
        }
      });
    } catch (err) {
      console.log('cannot remove from localStorage');
    }
  },

  saveItemWithExpiry(key, value, expiryMs) {
    try {
      const item = {
        value: value,
        expiry: new Date().getTime() + expiryMs,
      };
      const serializedItem = JSONUtils.stringifyJson(item);
      localStorage.setItem(key, serializedItem);
    } catch (err) {
      //ignore error
      console.log('cannot save to localStorage');
    }
  },

  getItemWithExpiry(key) {
    try {
      const serializedItem = localStorage.getItem(key);
      if (!serializedItem) return null;

      const item = JSONUtils.parseJson(serializedItem);
      const isExpired = new Date().getTime() > item.expiry;

      if (isExpired) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch (error) {
      return null;
    }
  },
};

export default LocalStorageUtils;
